$(document).ready(function(){
    const header = $('.ns-header');
    const headerHeight = header.outerHeight();
    const headerCatalog = $('.ns-header-catalog');

    const checkHeader = function () {
        if ($(document).scrollTop() >= headerHeight) {
            header.addClass('fixed');
            headerCatalog.addClass('_scroll');
            $('body').css('padding-top', headerHeight);
        } else {
            header.removeClass('fixed');
            headerCatalog.removeClass('_scroll');
            $('body').css('padding-top', 0);
        }
    }

    checkHeader();

    $(window).scroll(function () {
        checkHeader();
    });

    /*
     * Async script load
     * @param {string} url
     * @param {function} callback
     */
    function loadAsyncScript(url, callback) {
        var script = document.createElement("script");
        script.src = url;
        script.async = true;
        script.onload = callback;
        document.head.appendChild(script);
    }

    /*
     * Слайдер "Профессионалы выбирают"
     */
    $('.ns-section_main-professionals__slider').each(function () {
        const $this = $(this), swiper = new Swiper($this.find('.swiper')[0], {
            loop: true,
            slidesPerView: 3,
            spaceBetween: 16,
            centeredSlides: true,
            navigation: {
                nextEl: $(this).find('.swiper-button-next')[0],
                prevEl: $(this).find('.swiper-button-prev')[0],
            },
            breakpoints: {
                768: {
                    centeredSlides: false,
                    slidesPerView: 4,
                    spaceBetween: 18,
                },
                992: {
                    centeredSlides: false,
                    slidesPerView: 5,
                    spaceBetween: 22,
                },
                1200: {
                    centeredSlides: false,
                    slidesPerView: 6,
                    spaceBetween: 27,
                },
            }
        });

        swiper.on('slideChange', function(){
            const roleText = $this.find('.swiper .swiper-slide:eq('+this.activeIndex+')').children('div:eq(2)').html();

            $this.find('.ns-section_main-professionals__slider-role').html(roleText);
        });
    });

    /*
     * Blog
     */
    $('.ns-blog-list__item-image').click(function(e){
        e.stopPropagation();
        return false;
    });

    /*
     * Contacts block
     */
    $('.ns-section_contacts__content-right').each(function () {
        let scrollContactsContentLeft = 0, myMap;

        let oldCoordinates = null, oldZoom = null;

        const $map = $(this).find('.ns-section_contacts__content-map'), pointsData = [], geoObjects = [],
            imageIconUrl = '/img/ns/map-icon.svg', imageIconActiveUrl = '/img/ns/map-icon-active2.svg',
            startCoordinates = [55.755864, 37.617698];

        const contactsShowMobileIcons = $(window).outerWidth() < 768,
            contactsIconImageSize = contactsShowMobileIcons ? [36, 36] : [50, 50],
            contactsIconImageOffset = contactsShowMobileIcons ? [-18, -18] : [-25, -25],
            contactsIconImageSizeActive = contactsShowMobileIcons ? [187, 50] : [268, 72],
            contactsIconImageOffsetActive = contactsShowMobileIcons ? [-94, -25] : [-134, -36];

        const img = new Image();
        img.src = imageIconUrl;

        const swiper = new Swiper($(this).find('.swiper')[0], {
            slidesPerView: 1,
            pagination: {
                el: $(this).find('.swiper-pagination')[0],
                clickable: true,
            },
            breakpoints: {
                768: {
                    pagination: false,
                }
            },
            on: {
                slideChange: function () {
                    $('.ns-section_contacts__content-gallery > div:eq(1) > div').removeClass('_active');
                    $('.ns-section_contacts__content-gallery > div:eq(1) > div:eq(' + this.activeIndex + ')').addClass('_active');
                },
            }
        }), setProducts = function($leftItem, products){
            for (let i in products){
                let shortName = products[i].name,
                    fullName = products[i].name.replace(/[^a-zA-Z0-9\sа-яА-ЯёЁ]/g, '');

                if (shortName.length > 30){
                    shortName = shortName.substring(0, 27) + '...';
                }

                $leftItem.children('div:eq(1)').append('<a href="'+products[i].url+'" target="_blank" title="'+fullName+'">' +
                    '<img alt="" src="'+products[i].image+'">' +
                    '<div>' +
                    '<span>' + shortName + '</span>' +
                    '<svg width="4" height="6" viewBox="0 0 4 6" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                    '<path d="M2.3 3L0 0.7L0.7 0L3.7 3L0.7 6L0 5.3L2.3 3Z" fill="#2C2C2C"/>' +
                    '</svg>' +
                    '</div>' +
                    '</a>');
            }
        };
        $('.ns-section_contacts__content-gallery > div:eq(1)').on('click', 'div', function () {
            const index = $(this).index();

            swiper.slideTo(index);
        });
        $('.ns-section_contacts__content-tabs > button').click(function () {
            if (!$(this).hasClass('_active')) {
                $('.ns-section_contacts__content-gallery').toggleClass('_active', $(this).attr('data-type') === 'photo');
                $('.ns-section_contacts__content-tabs > button._active').removeClass('_active');
                $(this).addClass('_active');
            }
        });

        $('.ns-section_contacts__content-left').on('click', '.ns-section_contacts__content-left-items > div button', function () {
            const index = $(this).parent().parent().index(),
                $container = $('.ns-section_contacts__content-left-container'),
                $gallery = $('.ns-section_contacts__content-gallery');



            if (!$container.hasClass('_no-scroll')) {
                scrollContactsContentLeft = $container.scrollTop();
            }

            $gallery.find('.swiper-wrapper').html('');
            $gallery.children('div:eq(1)').html('');
            if (pointsData[index] != null) {
                $('.ns-section_contacts__content-left-item div[data-type="name"]').html(pointsData[index].name);
                $('.ns-section_contacts__content-left-item div[data-type="address"]').html(pointsData[index].address);

                for (let i in pointsData[index].images) {
                    if (!pointsData[index].images[i].isVideo) {
                        $gallery.find('.swiper-wrapper').append('<div class="swiper-slide"><img alt="" src="' + pointsData[index].images[i].link + '" title="Увеличить фотографию"></div>');
                        $gallery.children('div:eq(1)').append('<div><img alt="" src="' + pointsData[index].images[i].thumb + '"></div>');
                        $gallery.children('div:eq(1)').children('div:eq(0)').addClass('_active');
                    }
                }

                swiper.update();
            }

            const $leftItem = $('.ns-section_contacts__content-left-item'),
                limit = $(window).outerWidth() < 768 ? 2 : 4,
                products = pointsData[index].products.slice(0, limit);

            $leftItem.addClass('_active').attr('data-index', index);
            $leftItem.children('div:eq(1)').html('');
            $leftItem.find('.ns-section_contacts__content-left-item-label').toggleClass('_show', pointsData[index].products.length > 0);
            $leftItem.find('.ns-section_contacts__content-left-item-nav').toggleClass('_show', pointsData[index].products.length > limit);
            $leftItem.children('div:eq(1)')
                .attr('data-offset', limit)
                .toggleClass('_show', pointsData[index].products.length > 0)
                .toggleClass('_show-rhombus', pointsData[index].products.length >= limit);

            setProducts($leftItem, products);

            $container.addClass('_no-scroll');
            $('.ns-section_contacts__content-left-items').removeClass('_active');

            $('.ns-section_contacts__content-tabs').toggleClass('_active', $gallery.find('.swiper-wrapper > div').length > 0);
            $('.ns-section_contacts__content-close').addClass('_show');

            if (!$gallery.find('.swiper-wrapper > div').length) {
                $('.ns-section_contacts__content-tabs > button[data-type="map"]').click();
            }

            oldCoordinates = myMap.getCenter();
            oldZoom = myMap.getZoom();

            for (let i in geoObjects) {
                if (i != index) {
                    geoObjects[i].options.set('visible', false);
                    geoObjects[i].options.set('iconImageHref', imageIconUrl);
                    geoObjects[i].options.set('iconImageSize', contactsIconImageSize);
                    geoObjects[i].options.set('iconImageOffset', contactsIconImageOffset);
                } else {
                    geoObjects[i].options.set('visible', true);
                    geoObjects[i].options.set('iconImageHref', imageIconActiveUrl);
                    geoObjects[i].options.set('iconImageSize', contactsIconImageSizeActive);
                    geoObjects[i].options.set('iconImageOffset', contactsIconImageOffsetActive);
                    myMap.setCenter(geoObjects[i].geometry.getCoordinates(), 14);
                }
            }
        });
        $('.ns-section_contacts__content-left-item > div:eq(0) > button, .ns-section_contacts__content-close').click(function () {
            const $container = $('.ns-section_contacts__content-left-container');

            $container.removeClass('_no-scroll');
            $('.ns-section_contacts__content-left-item, .ns-section_contacts__content-tabs').removeClass('_active');
            $('.ns-section_contacts__content-left-items').addClass('_active');
            $('.ns-section_contacts__content-tabs > button[data-type="map"]').click();
            $('.ns-section_contacts__content-close').removeClass('_show');
            $container.scrollTop(scrollContactsContentLeft);

            for (let i in geoObjects) {
                geoObjects[i].options.set('visible', true);
                geoObjects[i].options.set('iconImageHref', imageIconUrl);
                geoObjects[i].options.set('iconImageSize', contactsIconImageSize);
                geoObjects[i].options.set('iconImageOffset', contactsIconImageOffset);
            }

            myMap.setCenter(oldCoordinates, oldZoom);
        });
        $('.ns-section_contacts__content-left-item-nav button[data-action="prev"]').click(function () {
            const index= parseInt($(this).parents('.ns-section_contacts__content-left-item').attr('data-index')),
                $leftItem      = $('.ns-section_contacts__content-left-item');

            let offset   = parseInt($leftItem.children('div:eq(1)').attr('data-offset')),
                limit = $(window).outerWidth() < 768 ? 2 : 4;

            if (offset > limit) {
                let newOffset = offset - limit * 2;

                if (newOffset < 0) {
                    newOffset = 0;
                }

                const products = pointsData[index].products.slice(newOffset, newOffset + limit);

                if (products.length) {
                    $leftItem.children('div:eq(1)')
                        .attr('data-offset', offset - $leftItem.children('div:eq(1)').children('a').length)
                        .toggleClass('_show-rhombus', products.length >= limit)
                        .html('');

                    setProducts($leftItem, products);
                }
            }
        });
        $('.ns-section_contacts__content-left-item-nav button[data-action="next"]').click(function () {
            const index= parseInt($(this).parents('.ns-section_contacts__content-left-item').attr('data-index')),
                $leftItem      = $('.ns-section_contacts__content-left-item');

            let offset = parseInt($leftItem.children('div:eq(1)').attr('data-offset')),
                limit = $(window).outerWidth() < 768 ? 2 : 4,
                newOffset = offset + limit;

            if (newOffset > pointsData[index].products.length){
                newOffset = pointsData[index].products.length;
            }

            const products = pointsData[index].products.slice(offset, newOffset);

            if (products.length) {
                $leftItem.children('div:eq(1)')
                    .attr('data-offset', newOffset)
                    .toggleClass('_show-rhombus', products.length >= limit)
                    .html('');

                setProducts($leftItem, products);
            }
        });

        $(document).on('click', '.ns-section_contacts__content-gallery .swiper-slide', function(){
            const $slider = $(this).parents('.swiper-wrapper'),
                images = [], currentIndex = $(this).index();

            $slider.find('.swiper-slide').each(function() {
                images.push({
                    src: $(this).find('img').attr('src')
                });
            });

            $.fancybox.open(images, {
                loop: true,
                thumbs: {
                    autoStart: true
                },
                index: currentIndex
            });
        });

        loadAsyncScript("https://api-maps.yandex.ru/2.1/?apikey=04709a29-6f21-442a-9cb5-272b39900456&lang=ru_RU", function () {
            ymaps.ready(function () {
                myMap = new ymaps.Map($map[0], {
                    center: startCoordinates,
                    zoom: 4,
                    controls: [],
                });

                const customZoomLayout = ymaps.templateLayoutFactory.createClass(
                    `<div style="display: flex;">
                        <button id="contacts-zoom-in" style="background: white; border: 1px solid #2C2C2C; border-radius: 0px; width: 40px; height: 40px; cursor: pointer; display: flex; align-items: center; justify-content: center;">
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6 8H0V6H6V0H8V6H14V8H8V14H6V8Z" fill="#2C2C2C"/>
                            </svg>
                        </button>
                        <button id="contacts-zoom-out" style="background: white; border: 1px solid #2C2C2C; border-left: transparent; border-radius: 0px; width: 40px; height: 40px; font-size: 18px; cursor: pointer; display: flex; align-items: center; justify-content: center;">
                            <svg width="14" height="2" viewBox="0 0 14 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0 2V0H14V2H0Z" fill="#2C2C2C"/>
                            </svg>
                        </button>
                     </div>`,
                    {
                        build: function () {
                            customZoomLayout.superclass.build.call(this);
                            // Привязываем обработчики событий к кнопкам
                            document.getElementById('contacts-zoom-in').onclick = () => myMap.setZoom(myMap.getZoom() + 1, { duration: 200 });
                            document.getElementById('contacts-zoom-out').onclick = () => myMap.setZoom(myMap.getZoom() - 1, { duration: 200 });
                        },
                        clear: function () {
                            // Убираем обработчики событий
                            document.getElementById('contacts-zoom-in').onclick = null;
                            document.getElementById('contacts-zoom-out').onclick = null;
                            customZoomLayout.superclass.clear.call(this);
                        }
                    }
                );

                const zoomControl = new ymaps.control.ZoomControl({
                    options: {
                        layout: customZoomLayout,
                        position: {
                            bottom: 30,
                            right: 25
                        }
                    }
                });

                myMap.controls.add(zoomControl);

                myMap.behaviors.disable(['scrollZoom']);

                $.getJSON($map.attr('data-json'), function (data) {
                    data.map(function (geoObject, idx) {
                        $('.ns-section_contacts__content-left-items').append(
                            '<div>' +
                            '<div>' + geoObject.name + '</div>' +
                            '<div>' +
                            '<div>' + geoObject.address + '</div>' +
                            '<button type="button">Подробнее</button>' +
                            '</div>' +
                            '</div>'
                        );

                        const myPlacemark = new ymaps.Placemark(geoObject.coords, {
                            hintContent: geoObject.name
                        }, {
                            iconLayout: 'default#image',
                            iconImageHref: imageIconUrl,
                            iconImageSize: contactsIconImageSize,
                            iconImageOffset: contactsIconImageOffset
                        });

                        myPlacemark.events.add('click', function (e) {
                            if ($('.ns-section_contacts__content-left-item._active').length) {
                                $('.ns-section_contacts__content-tabs._active button[data-type="photo"]').click();
                            } else {
                                $('.ns-section_contacts__content-left-items > div:eq(' + idx + ') button').click();
                            }
                        });

                        myMap.geoObjects.add(myPlacemark);

                        geoObjects.push(myPlacemark);
                        pointsData.push(geoObject);
                    });
                });
            });
        });
    });

    let ourWorksSwiper = null, $ourWorksTempItem, ourWorksOffset = 0;

    $('.js-ns-our-works-show').click(function () {
        const $item = $(this),
            $products = $item.find('.ns-our-works-content__item-products'),
            $images = $item.find('.ns-our-works-content__item-images'),
            $modalProducts = $('.modal-works__left-products'),
            $modalSlider = $('.modal-works__right-slider'),
            $modalThumbs = $('.modal-works__right-thumbs'),
            $modalLabel = $('.modal-works__left-label'),
            $modalNav = $('.modal-works__left-nav');

        $ourWorksTempItem = $item;
        ourWorksOffset = 6;
        $modalProducts.html('');
        $modalLabel.removeClass('_show');
        $modalNav.removeClass('_show');
        $modalProducts.removeClass('_show');

        $('.modal-works__left-name').text($item.find('.ns-our-works-content__item-title').text());

        if ($products.length) {
            $modalProducts.addClass('_show');
            $modalLabel.addClass('_show');
            $modalNav.toggleClass('_show', $products.find('a').length > 6);
            ourWorksOffset = $products.find('a').length > 6 ? 6 : $products.find('a').length;
            $products.find('a').each(function(index){
                $modalProducts.append($(this).prop('outerHTML'));

                if (index >= 5){
                    return false;
                }
            });

            $modalProducts.find('img').each(function () {
                $(this).attr('src', $(this).attr('data-src'));
                $(this).removeAttr('data-src');
            });
        }

        $modalSlider.find('.swiper-wrapper').html('');
        $modalThumbs.html('');

        if ($images.length){
            $modalSlider.find('.swiper-wrapper').html($images.html());

            $modalSlider.find('.swiper-wrapper img').each(function(){
                $(this).attr('src', $(this).attr('data-src'));
                $(this).removeAttr('data-src');
                $(this).addClass('swiper-slide');

                $modalThumbs.append('<div><img alt="" src="' + $(this).attr('src') + '"></div>');
            });

            $modalThumbs.find('div:first').addClass('_active');

            if (ourWorksSwiper == null) {
                ourWorksSwiper = new Swiper($modalSlider[0], {
                    slidesPerView: 1,
                    pagination: {
                        el: $modalSlider.find('.swiper-pagination')[0],
                        clickable: true,
                    },
                    breakpoints: {
                        992: {
                            pagination: false,
                        }
                    },
                    on: {
                        slideChange: function () {
                            $('.modal-works__right-thumbs > div').removeClass('_active');
                            $('.modal-works__right-thumbs > div:eq(' + this.activeIndex + ')').addClass('_active');
                        },
                    }
                });
            } else {
                ourWorksSwiper.update();
            }
        }

        openModal($('#modal-works'), 'modal-bg');
    });

    $(document).on('click', '.modal-works__right-thumbs > div', function(){
        const index = $(this).index();

        ourWorksSwiper.slideTo(index);
    }).on('click', '.modal-works__right-slider img', function(){
        const $slider = $(this).parents('.swiper-wrapper'),
            images = [], currentIndex = $(this).index();

        $slider.find('img').each(function() {
            images.push({
                src: $(this).attr('src')
            });
        });

        $.fancybox.open(images, {
            loop: true,
            thumbs: {
                autoStart: true
            },
            index: currentIndex
        });
    }).on('click', '.modal-works__left-nav button[data-action="prev"]', function(){
        const $products = $ourWorksTempItem.find('.ns-our-works-content__item-products'),
            $modalProducts = $('.modal-works__left-products');

        if (ourWorksOffset > 6){
            ourWorksOffset -= 6;

            $modalProducts.html('');

            $products.find('a').slice(ourWorksOffset - 6, ourWorksOffset).each(function(index){
                $modalProducts.append($(this).prop('outerHTML'));
            });

            $modalProducts.find('img').each(function () {
                $(this).attr('src', $(this).attr('data-src'));
                $(this).removeAttr('data-src');
            });
        }
    }).on('click', '.modal-works__left-nav button[data-action="next"]', function(){
        const $products = $ourWorksTempItem.find('.ns-our-works-content__item-products'),
            count = $products.find('a').length,
            $modalProducts = $('.modal-works__left-products');

        let newOffset = ourWorksOffset + 6;

        if (newOffset > count.length){
            newOffset = count.length;
        }

        const $selfProducts = $products.find('a').slice(ourWorksOffset, newOffset);

        if ($selfProducts.length) {
            $modalProducts.html('');

            $selfProducts.each(function (index) {
                $modalProducts.append($(this).prop('outerHTML'));
            });

            ourWorksOffset = newOffset;

            $modalProducts.find('img').each(function () {
                $(this).attr('src', $(this).attr('data-src'));
                $(this).removeAttr('data-src');
            });
        }
    });

    /*
     * Header
     */
    $('.js-ns-header-catalog-toggle').click(function () {
        const $catalog = $('.ns-header-catalog'), $promo = $('.top-promo'),
            headerAdminBar = $('#adminbar');

        if (!$catalog.hasClass('_active')) {
            let height = $(window).outerHeight() - headerHeight,
                offset = headerHeight;

            if ($promo.is(':visible') && $(window).scrollTop() <= 0) {
                offset += $promo.outerHeight();
                height -= $promo.outerHeight();
            }

            if (headerAdminBar.length){
                offset += headerAdminBar.outerHeight() - 3;
                height -= headerAdminBar.outerHeight() - 3;
            }

            $catalog.css({
                height: height,
                top: offset,
            }).addClass('_active');
            $('body').addClass('ns-lock');
        } else {
            $catalog.removeClass('_active');
            $('body').removeClass('ns-lock');
        }
    });

    $('.js-ns-header-section-link').click(function(e){
        const $catalog = $('.ns-header-catalog');
        const linkParts = $(this).attr('href').split('#'),
            linkHref = linkParts[0],
            linkHash = linkParts[1];
        const currentPath = window.location.pathname;

        if (linkHref === currentPath) {
            $catalog.removeClass('_active');
            $('body').removeClass('ns-lock');

            if ($('#' + linkHash).length){
                e.preventDefault();

                $('html, body').animate({
                    scrollTop : $('#' + linkHash).offset().top - headerHeight - 100,
                }, 500);
            }
        }
    });

    $(window).resize(function () {
        const $catalog = $('.ns-header-catalog');

        if ($catalog.hasClass('_active')) {
            $catalog.removeClass('_active');
            $('body').removeClass('ns-lock');
        }
    });

    $('.ns-header-catalog__content-group > div').click(function () {
        $(this).toggleClass('_active');

        if ($(this).hasClass('_active')){
            $(this).next('ul').slideDown(300);
        } else {
            $(this).next('ul').slideUp(300);
        }
    });

    $(document).on('click', function (e) {
        const $target = $(e.target);

        if (
            $target.hasClass('ns-header-catalog') || $target.parents('.ns-header-catalog').length ||
            $target.hasClass('ns-header') || $target.parents('.ns-header').length
        ) {
            return true;
        }

        $('.ns-header-catalog').removeClass('_active');
    }).on('click touchstart', '.ns-header-catalog__content-categories a, .ns-header-catalog__content-group a', function(){
        const $this = $(this);

        if (!$this.hasClass('_active')){
            $this.addClass('_active');

            setTimeout(function(){
                $this.removeClass('_active');
            }, 2500);
        }
    });

    $('.js-ns-header-menu-trigger').click(function () {
        const $menu = $('.ns-header__center-menu'),
            $other = $('.ns-header__center-left, .ns-header__center-logo, .ns-header__center-right'),
            isActive = $menu.hasClass('_active');

        $('.ns-header-catalog').removeClass('_active');
        $('body').removeClass('ns-lock');

        if (isActive) {
            $other.animate({
                opacity: 0
            }, 300, function () {
                $menu.removeClass('_active');
                $other.removeClass('_hide');

                $other.css({
                    opacity: 0
                });

                $other.animate({
                    opacity: 1
                }, 300);
            });
        } else {
            $other.animate({
                opacity: 0
            }, 300, function () {
                $other.addClass('_hide');
                $menu.addClass('_active');

                $menu.css({
                    opacity: 0
                });

                $menu.animate({
                    opacity: 1
                }, 300);
            });
        }
    });
    /////////////////////////

    $('.js-switch-login-form-type').click(function(){
        const $modal = $('#sign-in'),
            type = $(this).attr('data-type'),
            label = $(this).attr('data-label');

        $(this).attr('data-label', $(this).text())
            .text(label);

        if (type === 'email') {
            $(this).attr('data-type', 'phone');
            $modal.find('[name="LoginForm[email]"]').attr('placeholder', '+7 000 000 00 00')
                .prev().text('Номер телефона');
            $modal.find('.modal-form__title').html('Войдите <br> или создайте аккаунт');
            $modal.find('.modal-form__description').removeClass('show');
            $modal.find('.modal-form__tabs').addClass('show');
        } else {
            $(this).attr('data-type', 'email');
            $modal.find('[name="LoginForm[email]"]').attr('placeholder', 'ivan.ivanov@gmail.com')
                .prev().text('Адрес электронной почты');
            $modal.find('.modal-form__title').html('Войти по<br> электронной почте');
            $modal.find('.modal-form__description').addClass('show');
            $modal.find('.modal-form__tabs').removeClass('show');
        }
    });

    $(document).on('click', '.js-ns-search-open', function(e){
        const $wrap = $(this).parent();

        $wrap.addClass('open');
        $wrap.find('input').focus();
        $wrap.find('input').click();

        $('.ns-header__center-menu, .ns-header-catalog')
            .removeClass('_active')
            .removeAttr('style');
        $('.ns-header__center-left, .ns-header__center-logo, .ns-header__center-right').removeClass('_hide')
            .removeAttr('style');
    }).on('click', '.js-ns-search-clear', function(){
        const $form = $(this).parents('form'), $wrap = $form.parent();

        $form.find('input').val('');

        if ($wrap.hasClass('open')) {
            $('.ns-header__center-left, .ns-header__center-logo, .ns-header__center-right').removeClass('_hide');
            $('.ns-header__center').removeClass('open-search');
        }

        $wrap.removeClass('open').removeClass('active');

        if ($('.ns-header__center .js-ns-search-wrap').length){
            $('.ns-header > div').append($('.js-ns-search-wrap'));
        }
    }).on('click', '.js-ns-search-mobile-trigger', function(){
        if (!$('.ns-header__center .js-ns-search-wrap').length){
            $('.ns-header__center').append($('.js-ns-search-wrap'));
        }

        $('.ns-header__center-left, .ns-header__center-logo, .ns-header__center-right').addClass('_hide');
        $('.js-ns-search-wrap').addClass('open')
            .find('input').focus().click();
        $('.ns-header__center').addClass('open-search');
    }).on('click', function(e) {
        var headerSearch = $('.js-ns-search-wrap');
        if (!headerSearch.is(e.target) || headerSearch.has(e.target).length === 0) {
            headerSearch.removeClass('active');
        }

        if (!$(e.target).hasClass('js-ns-search-wrap') && !$(e.target).parents('.js-ns-search-wrap').length &&
            !$(e.target).hasClass('.js-ns-search-mobile-trigger') && !$(e.target).parents('.js-ns-search-mobile-trigger').length) {
            if (headerSearch.hasClass('open')) {
                $('.ns-header__center-left, .ns-header__center-logo, .ns-header__center-right').removeClass('_hide');
            }

            headerSearch.removeClass('open');
            $('.ns-header__center').removeClass('open-search');
            if ($('.ns-header__center .js-ns-search-wrap').length){
                $('.ns-header > div').append($('.js-ns-search-wrap'));
            }
        }
    }).on('click', '.ns-delivery-tabs__tab-header', function(){
        const $tab = $(this).parents('.ns-delivery-tabs__tab');

        $tab.toggleClass('_show');
        $tab.find('.ns-delivery-tabs__tab-content').slideToggle(300);
    }).on('click', '.ns-delivery-tabs__subtab-header', function(e){
        e.stopImmediatePropagation();

        const $tab = $(this).parents('.ns-delivery-tabs__subtab');

        $tab.find('.ns-delivery-tabs__subtab-content').slideToggle(300);
        $tab.toggleClass('_show');
    }).on('submit', '.ns-footer__subs-form', function(e){
        e.preventDefault();

        const $form = $(this);

        if (!$form.hasClass('_loading')){
            $form.find('.ns-footer__subs-form-info').hide();

            if (!$form.find('[name="check"]').prop('checked')){
                console.log(1);

                $form.find('[name="check"]').parents('.ns-footer__subs-form-input')
                    .find('.ns-footer__subs-form-info').show()
                    .text('Необходимо подтвердить');
                return;
            }

            $.ajax({
                url: '/subscription/subscription-submit/',
                method: 'post',
                data : {
                    email : $form.find('[name="email"]').val(),
                },
                beforeSend: function(){
                    $form.addClass('_loading');
                },
                dataType: 'json',
                success : function(data){
                    $form.removeClass('_loading');

                    if (data.status === 'valid_error'){
                        const keys = Object.keys(data.errors),
                            errors = data.errors[keys[0]], errorsKeys = Object.keys(errors),
                            firstErrors = errors[errorsKeys[0]];

                        $form.find('[name="email"]').parents('.ns-footer__subs-form-input').find('.ns-footer__subs-form-info').show()
                            .text(firstErrors[0]);
                    } else {
                        $form[0].reset();
                        openModal($('#modal-subscribe'), 'modal-bg');

                        if (typeof ym === 'function'){
                            ym(35907125,'reachGoal','rassilka');
                        }
                    }
                },
                error : function(){
                    $form.removeClass('_loading');
                }
            });
        }
    }).on('submit', '.js-ns-form', function(e){
        e.preventDefault();

        const $form = $(this);

        if (!$form.hasClass('_loading')){
            if($form.find('.g-recaptcha').length){
                if( $form.find(".g-recaptcha-response").val() === '') {
                    $.fancybox.open('Пожалуйста, подтвердите, что Вы не робот');
                    return false;
                }
            }

            if($form.find('input[name="check"]').length && !$form.find('input[name="check"]').prop('checked')){
                $.fancybox.open('Пожалуйста, подтвердите, согласие с политикой конфиденциальности');
                return false;
            }

            $form.addClass('_loading');
            $form.find('.help-block').hide();

            const data = {
                'anti_spam': 'anti_spam',
                'g-recaptcha-response' : $form.find(".g-recaptcha-response").val(),
            };

            $form.find('input[type="text"], input[type="tel"], input[type="email"], textarea').each(function(){
                data[$(this).attr('name')] = $(this).val();
            });

            $.ajax({
                url: $form.attr('action'),
                method: 'post',
                data : data,
                dataType: 'json',
                success : function(data){
                    $form.removeClass('_loading');

                    if (data.status === 'valid_error'){
                        const keys = Object.keys(data.errors),
                            errors = data.errors[keys[0]];

                        for (let i in errors) {
                            $form.find('[name="' + i + '"]')
                                .parents('.ns-form__group')
                                .find('.help-block').show()
                                .text(errors[i][0]);
                        }
                    } else {
                        $form[0].reset();
                        openModal($($form.attr('data-success-modal')), 'modal-bg');
                    }
                },
                error : function(){
                    $form.removeClass('_loading');
                }
            });
        }
    }).on('mouseenter', '.ns-enhance-skills > a', function(){
        const $video = $(this).find('.ns-enhance-skills__item-video');

        if ($(window).outerWidth() > 767){
            $video.addClass('_show');
            $(this).addClass('_video-active');

            setTimeout(function(){
                $video[0].play();
            }, 10);
        } else {
            $video.removeClass('_show');
            $(this).removeClass('_video-active');

            setTimeout(function(){
                $video[0].pause();
            }, 10);
        }
    }).on('mouseleave', '.ns-enhance-skills > a', function(){
        const $video = $(this).find('.ns-enhance-skills__item-video');

        $video.removeClass('_show');

        setTimeout(function(){
            $video[0].pause();
        }, 10);
    });

    $('.ns-enhance-skills__item-video').each(function(){
        if ($(window).outerWidth() > 767){
            $(this).attr('autoplay', '');
        }
    });
});
